import { render } from "./FilesList.vue?vue&type=template&id=43eafecb&scoped=true"
import script from "./FilesList.vue?vue&type=script&lang=js"
export * from "./FilesList.vue?vue&type=script&lang=js"

import "./FilesList.vue?vue&type=style&index=0&id=43eafecb&scoped=true&lang=scss"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43eafecb"]])

export default __exports__